import { Input } from 'reactstrap';

export const columns = [
    {
        name: 'Name',
        minWidth: '180px',
        grow: 1,
        selector: (row) => row.name,
        cell: (row) => (
            <div className="d-flex justify-content-left align-items-center">
                <div className="d-flex flex-column">
                    <p className="user_name text-truncate text-body">
                        <span className="fw-bolder">
                            {row.name || 'Anonymous'}
                        </span>
                    </p>
                </div>
            </div>
        ),
    },
    {
        name: 'Email',
        minWidth: '180px',
        grow: 2,

        selector: (row) => row.email,
        cell: (row) => (
            <div className="d-flex justify-content-left align-items-center">
                <div className="d-flex flex-column">
                    <p className="user_name text-truncate text-body">
                        <span className="fw-bolder">
                            {row.email || 'Anonymous'}
                        </span>
                    </p>
                </div>
            </div>
        ),
    },
    {
        name: 'Address',
        minWidth: '150px',
        grow: 2,
        allowOverflow: true,
        selector: (row) => row.account,
        cell: (row) => (
            <div className="d-flex justify-content-left align-items-center">
                <p className="text-truncate text-body">
                    <span className="fw-bolder">{`${row.account.slice(
                        0,
                        5
                    )}...${row.account.slice(-7)}`}</span>
                    <br />
                </p>
            </div>
        ),
    },
    {
        name: 'Set admin',
        minWidth: '150px',
        grow: 0.5,
        selector: (row) => row.isAdmin,
        cell: (row) => (
            <div className="d-flex justify-content-left align-items-center">
                <div className="form-switch mb-2 ps-0">
                    <Input
                        style={{
                            marginLeft: 0,
                            width: '45px',
                            cursor: 'pointer',
                        }}
                        type="switch"
                        name="isAdmin"
                        checked={row.isAdmin}
                        onChange={() => row.setAdmin(!row.isAdmin)}
                    />
                </div>
            </div>
        ),
    },
];
